module.exports = __webpack_public_path__ + "img/LM.4380d57a.png";